<template>
    <modal ref="modal">
        <div id="sub-wrapper">
            <form @submit="submit">
              <div class="title">{{ capitalize(distributor) }}</div>
              <div class="description" v-if="distributor === 'instagram' || distributor === 'tiktok'" v-html="$t('modals.create_distributor.descriptions.' + distributor)"></div>
              <div>
                  <label>{{ $t('labels.server_url') }} *</label>
                  <input ref="server_url" v-model="serverUrl" type="text" :class="errors['server_url'] ? 'error' : ''"/>
                  <div class="error" v-if="errors['server_url']">{{ errors['server_url'] }}</div>
              </div>
              <div>
                  <label>{{ $t('labels.stream_key') }} *</label>
                  <input ref="stream_key" v-model="streamKey" type="text" :class="errors['stream_key'] ? 'error' : ''"/>
                  <div class="error" v-if="errors['stream_key']">{{ errors['stream_key'] }}</div>
              </div>
              <button>{{ $t('modals.create_distributor.button') }}</button>
            </form>
        </div>
    </modal>
</template>

<script>
import distributor from '@/services/distributor'

export default {
  data () {
    return {
      defaultErrKey: 'server_url',
      distributor: '',
      errors: {},
      eventId: '',
      serverUrl: '',
      streamKey: ''
    }
  },
  methods: {
    capitalize (name) {
      if (name === 'rtmp') return name.toUpperCase()
      return name.charAt(0).toUpperCase() + name.slice(1)
    },
    show (eventId, distributor) {
      // Init
      this.distributor = distributor
      this.errors = {}
      this.eventId = eventId
      this.serverUrl = ''
      this.streamKey = ''

      // Default rtmp urls
      switch (this.distributor) {
        case 'instagram':
          this.serverUrl = 'rtmps://live-upload.instagram.com:443/rtmp/'
          break
      }

      // Show
      this.$refs.modal.show()

      // Focus
      this.$nextTick(function () {
        switch (this.distributor) {
          case 'instagram':
            this.$refs.stream_key.focus()
            break
          default:
            this.$refs.server_url.focus()
            break
        }
      }.bind(this))
    },
    hide () {
      this.$refs.modal.hide()
    },
    submit (e) {
      // Init
      e.preventDefault()
      this.errors = {}

      // Check server url
      if (!this.serverUrl || this.serverUrl === '') {
        this.errors = { 'server_url': this.$i18n.t('mandatory.server_url') }
        return
      }

      // Check stream key
      if (!this.streamKey || this.streamKey === '') {
        this.errors = { 'stream_key': this.$i18n.t('mandatory.stream_key') }
        return
      }

      // Show loader
      this.$parent.$parent.$parent.$refs.loader.show()

      // Create distributor
      distributor.create(this.eventId, this.distributor, this.serverUrl, this.streamKey)
        .then(() => {
          // Hide loader
          this.$parent.$parent.$parent.$refs.loader.hide()

          // Hide modal
          this.hide()
        })
        .catch(err => {
          // Hide loader
          this.$parent.$parent.$parent.$refs.loader.hide()

          // Update error
          if (err.messages) {
            this.errors = err.messages
          } else {
            this.errors = {}
            this.errors[this.defaultErrKey] = this.$i18n.t('errors.default')
          }
        })
    }
  }
}
</script>

<style scoped>

#sub-wrapper {
  width: 25em;
}

</style>
